module.exports = __webpack_public_path__ + "img/92.7.Chla.7a255627.png";